import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isEqual from "lodash/isEqual";
var _excluded = ["as", "fields", "onValid"],
  _excluded2 = ["disableIfValuesUnchanged", "as"],
  _excluded3 = ["as", "name", "required", "validate", "onChange", "transform"],
  _excluded4 = ["name", "as"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { createElement, createContext, useContext, useEffect, useState } from 'react';
import { useForm as useReactHookForm, useFieldArray as useReactHookFieldArray, Controller, useWatch } from 'react-hook-form';

// Because of the way Form / Field and TS work, it's not possible for us to safely know
// the actual form values are on submit.  For now, let's just assume all values are `unknown`.
// There might be a way to add some schema validation using something like zod to make
// this type-safe and have narrower types

var FormControlContext = /*#__PURE__*/createContext(null);
var FormTriggerContext = /*#__PURE__*/createContext(null);
var HandleSubmitContext = /*#__PURE__*/createContext(null);
var OnSubmitContext = /*#__PURE__*/createContext(null);
var OnSubmitErrorContext = /*#__PURE__*/createContext(undefined);
var SetValueContext = /*#__PURE__*/createContext(null);
var FieldArrayPrefixContext = /*#__PURE__*/createContext(null);
var DefaultValuesContext = /*#__PURE__*/createContext(null);
export var Form = function Form(props) {
  var _useReactHookForm = useReactHookForm({
      defaultValues: props.defaultValues
    }),
    handleSubmit = _useReactHookForm.handleSubmit,
    control = _useReactHookForm.control,
    trigger = _useReactHookForm.trigger,
    setValue = _useReactHookForm.setValue;
  var parentSetValue = useContext(SetValueContext);
  if (parentSetValue) {
    // We do not allow rendering a form inside a form.  Nested forms are invalid
    // HTML.  If you think you need nested forms, there is probably a different
    // solution to this.  Please do not remove this error.
    throw new Error('Can not render a form inside of another form');
  }
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      return false;
    }
  }, /*#__PURE__*/React.createElement(SetValueContext.Provider, {
    value: setValue
  }, /*#__PURE__*/React.createElement(OnSubmitContext.Provider, {
    value: props.onSubmit
  }, /*#__PURE__*/React.createElement(OnSubmitErrorContext.Provider, {
    value: props.onSubmitError
  }, /*#__PURE__*/React.createElement(HandleSubmitContext.Provider, {
    value: handleSubmit
  }, /*#__PURE__*/React.createElement(FormControlContext.Provider, {
    value: control
  }, /*#__PURE__*/React.createElement(FormTriggerContext.Provider, {
    value: trigger
  }, /*#__PURE__*/React.createElement(DefaultValuesContext.Provider, {
    value: props.defaultValues
  }, props.children))))))));
};
export function ValidateButton(props) {
  var trigger = useContext(FormTriggerContext);
  if (!trigger) {
    throw new Error('ValidateButton can only be rendered inside a Form component');
  }

  // @ts-expect-error: manual prop-checking
  if (props.onClick) {
    throw new Error('onClick prop is not supported on ValidateButton');
  }
  var as = props.as,
    fields = props.fields,
    onValid = props.onValid,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/createElement(as, _objectSpread({
    onClick: function () {
      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return trigger(fields);
            case 2:
              result = _context.sent;
              if (result) {
                onValid();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, otherProps));
}
export function SubmitButton(props) {
  var trigger = useContext(FormTriggerContext);
  var onSubmit = useContext(OnSubmitContext);
  var onSubmitError = useContext(OnSubmitErrorContext);
  var handleSubmit = useContext(HandleSubmitContext);
  var defaultValues = useContext(DefaultValuesContext);
  var control = useContext(FormControlContext);
  if (!trigger || !control) {
    throw new Error('SubmitButton can only be rendered inside a Form component');
  }
  var values = useWatch({
    control: control
  });
  if (!onSubmit) {
    throw new Error('Form is missing an onSubmit handler');
  }

  // Should provide "type='submit'" to make it clear this is a submit button. If
  // we force the consumer to add "type='submit'" then it's more likely the
  // underlying component will render a submit button, which is intended
  if (props.type !== 'submit') {
    throw new Error("Must provide type prop that is equal to 'submit'.  " + "Make sure this 'type' prop is passed down to the root button element");
  }
  var disableIfValuesUnchanged = props.disableIfValuesUnchanged,
    as = props.as,
    forwardedProps = _objectWithoutProperties(props, _excluded2);

  // @ts-expect-error: complicated overload match
  return /*#__PURE__*/createElement(as, _objectSpread(_objectSpread({}, forwardedProps), {}, {
    disabled: function () {
      if (props.disabled) {
        return true;
      }
      if (disableIfValuesUnchanged && _isEqual(values, defaultValues)) {
        return true;
      }
      return false;
    }(),
    onClick: function onClick(e) {
      var form = e.currentTarget.form;
      if (!form) {
        throw new Error('It appears this submit button is not associated with a form');
      }

      // So this is a little weird but we cancel the submit when it happens
      //
      // This is so we can manually trigger the validation and then trigger the
      // submit again
      //
      // We do this to prevent the native validation UI from popping up, which
      // does not match the crystal design system
      e.preventDefault();
      trigger().then(function (isValid) {
        if (isValid) {
          // See: https://github.com/react-hook-form/react-hook-form/issues/566#issuecomment-612328736
          // and: https://react-hook-form.com/api/useform/handlesubmit
          handleSubmit(onSubmit)();
        } else if (onSubmitError) {
          handleSubmit(onSubmit, function (errors) {
            var simpleErrors = simplifyErrorStructure(errors);
            onSubmitError(simpleErrors);
          })();
        }
      });

      // Return false to make sure the form submit is cancelled
      return false;
    }
  }));
}

/**
 * These are the props that the component passed to the Field component's "as" prop should accept
 */

export function Field(props) {
  var control = useContext(FormControlContext);
  var fieldArrayPrefix = useContext(FieldArrayPrefixContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFieldRegistered = _useState2[0],
    setIsFieldRegistered = _useState2[1];
  useEffect(function () {
    setIsFieldRegistered(true);
  }, []);
  if (!control) {
    throw new Error('Field can only be rendered inside a Form component');
  }

  // @ts-expect-error: manual prop-checking
  if (props.value) {
    throw new Error('props.value is not supported on Field');
  }

  // @ts-expect-error: manual prop-checking
  if (props.error) {
    throw new Error('props.error is not supported on Field');
  }
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "".concat(fieldArrayPrefix || '').concat(props.name),
    rules: {
      validate: function validate(value) {
        var customValidateResult = props.validate ? props.validate(value) : true;
        if (typeof customValidateResult === 'string' || customValidateResult === false) {
          return customValidateResult;
        }
        if (props.required) {
          var emptyString = typeof value === 'string' && value.trim() === '';
          var hasValue = !emptyString && (!Array.isArray(value) || value.length > 0) && value !== null && typeof value !== 'undefined';
          if (!hasValue) {
            if (typeof props.required === 'string') {
              return props.required;
            }
            return 'This field is required';
          }
        }
        if (typeof value === 'string' && props.maxLength && countHtmlLength(value) > props.maxLength) {
          return "Please use no more than ".concat(props.maxLength, " characters.");
        }
        return true;
      }
    },
    render: function render(_ref) {
      var _props$transform, _fieldState$error;
      var field = _ref.field,
        fieldState = _ref.fieldState;
      // So this looks kind of weird eh?
      //
      // Why are we returning `null` if `isFieldRegistered` is `false`?
      //
      // Wait... isFieldRegistered is just a state variable that we set to true inside a
      // useEffect?  Whyyyyy?
      //
      // Glad you ask.  It's to work around a bug with react-hook-form.  If
      // you have a custom component (such as FileTypesField) that calls
      // onChange within a useEffect, react-hook-form will miss this onChange
      // call
      //
      // The reason is because Controller registers the field within an
      // internal useEffect:
      // https://github.com/react-hook-form/react-hook-form/blob/9a3476d810dd15047b4b539af3eccd002cb6cf77/src/useController.ts#L76-L99
      //
      // The field needs to be "registered" before onChange calls.
      //
      // However, effects are called in reverse tree order.  So children's
      // useEffects are called before parent's useEffects See:
      // https://codepen.io/benlorantfy/pen/bGEJveX
      //
      // This means we call onChange before the field is registered.
      //
      // This workaround renders null until the field is registered, since
      // setIsReady will be called after the field is registered, due to the
      // useEffect ordering described above
      if (!isFieldRegistered) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var as = props.as,
        name = props.name,
        required = props.required,
        validate = props.validate,
        _onChange = props.onChange,
        transform = props.transform,
        otherProps = _objectWithoutProperties(props, _excluded3);

      // @ts-expect-error: complicated overload match
      return /*#__PURE__*/createElement(props.as, _objectSpread({
        onChange: function onChange(arg) {
          var value = getEventValue(arg);
          if (transform !== null && transform !== void 0 && transform.output) {
            var transformed = transform.output(value);
            field.onChange(transformed);
            if (_onChange) {
              _onChange(transformed);
            }
          } else {
            field.onChange(value);
            if (_onChange) {
              _onChange(value);
            }
          }
        },
        value: (_props$transform = props.transform) !== null && _props$transform !== void 0 && _props$transform.input ? props.transform.input(field.value) : field.value,
        onBlur: field.onBlur,
        error: !!fieldState.error,
        required: Boolean(props.required),
        helperText: typeof ((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message) === 'string' ? fieldState.error.message : props.helperText
      }, otherProps));
    }
  });
}

/**
 * These are the props that the component passed to the FieldArray component's "as" prop should accept
 */

export function FieldArray(props) {
  var control = useContext(FormControlContext);
  var fieldArrayPrefix = useContext(FieldArrayPrefixContext);
  if (!control) {
    throw new Error('FieldArray can only be rendered inside a Form component');
  }
  var name = props.name,
    as = props.as,
    otherProps = _objectWithoutProperties(props, _excluded4);
  var _useReactHookFieldArr = useReactHookFieldArray({
      control: control,
      name: "".concat(fieldArrayPrefix || '').concat(props.name)
    }),
    fields = _useReactHookFieldArr.fields,
    append = _useReactHookFieldArr.append,
    remove = _useReactHookFieldArr.remove;
  if (!name) {
    throw new Error('props.name is required on FieldArray');
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, fields.map(function (field, index) {
    return /*#__PURE__*/React.createElement(FieldArrayPrefixContext.Provider, {
      key: field.id,
      value: "".concat(fieldArrayPrefix || '').concat(name, "[").concat(index, "].")
    },
    /*#__PURE__*/
    // @ts-expect-error: complicated overload match
    createElement(as, _objectSpread({
      append: append,
      remove: remove,
      index: index,
      arrayLength: fields.length
    }, otherProps)));
  }));
}
export function useFormValue(name) {
  var control = useContext(FormControlContext);
  var fieldArrayPrefix = useContext(FieldArrayPrefixContext);
  if (!control) {
    throw new Error('useFormValue can only be called within children of a Form component');
  }
  var value = useWatch({
    control: control,
    name: "".concat(fieldArrayPrefix || '').concat(name)
  });
  return value;
}
export function useSetFormValue() {
  var setValue = useContext(SetValueContext);
  var fieldArrayPrefix = useContext(FieldArrayPrefixContext);
  if (!setValue) {
    throw new Error('useSetFormValue can only be called within children of a Form component');
  }
  return function (fieldName, fieldValue) {
    setValue("".concat(fieldArrayPrefix || '').concat(fieldName), fieldValue);
  };
}
var isEvent = function isEvent(event) {
  return !!(_typeof(event) === 'object' && !(event instanceof Date) && event && event.target);
};
var isCheckBoxInput = function isCheckBoxInput(el) {
  return el.type === 'checkbox';
};

// This logic is roughly copied from https://github.com/react-hook-form/react-hook-form/blob/c4e0268f2258fce240f443a082229fd4dccdc732/src/logic/getEventValue.ts#L6-L11
function getEventValue(event) {
  return isEvent(event) ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
}
function simplifyErrorStructure(errors) {
  var simpleErrors = {};
  Object.entries(errors).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      field = _ref3[0],
      message = _ref3[1].message;
    simpleErrors[field] = message;
  });
  return simpleErrors;
}
export function countHtmlLength(htmlStr) {
  var div = document.createElement('div');
  div.innerHTML = htmlStr;
  return div.textContent.length;
}